import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CourseInfoTile from "../components/CourseInfoTile";
import CreateMessageFAB from "../components/CreateMessageFAB";
import Loader from "../components/Loader";
import SectionTile from "../components/SectionTile";

function CourseSections() {
  const params = useParams();
  const role = useSelector((state) => state.auth?.user?.role);
  const course = useSelector((state) =>
    state.pwaData?.courses.find(
      (course) => course.course_code === params.course_code
    )
  );
  const classes = useSelector((state) =>
    state.pwaData?.taught_classes.filter((cls) =>
      cls.courses.includes(params.course_code)
    )
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!course) {
    return <Loader />;
  }

  return (
    <div className="body-container">
      <CourseInfoTile course={course} />
      {classes?.map((cls) => (
        <SectionTile key={cls._id} cls={cls} />
      ))}
      {role === "Faculty" && <CreateMessageFAB course={course} />}
    </div>
  );
}

export default CourseSections;
